module.exports = __webpack_public_path__ + "static/media/kr.afdbdf93.jpeg";